angular.module('cfn').controller('landsbergController', landsbergController);

landsbergController.$inject = [
  '$scope',
  '$location'
];
function landsbergController(
  $scope,
  $location
) {
  'use strict';

  /**
   * Only set href attribute if registrationKey param exists.
   * Otherwise linking between company and landsberg account is not possible.
   */
  $scope.initLandsbergRegistrationLink = function() {
    const registrationKeyParam = $location.search().registrationKey;
    const registrationLink = window.document.getElementById("landsberg-registration-link");
    registrationLink.href = "login.html#/registration?registrationContext=landsberg&landsbergRegistrationKey=" + registrationKeyParam;
  };

  $scope.initLandsbergRegistrationLink();
  $scope.landsbergController = this;

  return this;
}
